import React from "react";
import ForgotPassword from "components/Auth/ForgotPasswordForm";
import { withRouter } from "react-router-dom";
import Box from "components/common/Box";
import Grid from "components/common/Grid";
import Sidebar from "components/Auth/Sidebar";
import { validationHelper } from "helper/validation";
import { forgotPasswordApis } from "stores/ForgotPasswordStore/forgotPasswordApi";
import Snackbar from "components/common/Snackbar";
import { Alert } from "@mui/material";

class ForgotPasswordContainer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      email_mobile: "",
      ErrorMsg: "",
      setOpen: false,
      formError: {
        email_mobile: false,
        email: false,
        mobile: false,
      },

      snackbar: false,
    };
  }

  EmailMobileChecker = (val) => {
    this.setState({ email_mobile: val });
  };

  handleValidation = () => {
    const { formError } = this.state;
    const emailMobileValidation = validationHelper.emailORmobile(
      this.state.email_mobile
    );
    formError.email_mobile = emailMobileValidation.message;
    if (emailMobileValidation.emailValid) {
      formError.email = this.state.email_mobile;
      formError.mobile = "";
    }
    if (emailMobileValidation.mobileValid) {
      formError.mobile = this.state.email_mobile;
      formError.email = "";
    }

    this.setState({ formError });
    return emailMobileValidation.isValid;
  };

  handleFormSubmit = async () => {
    if (!this.handleValidation()) {
      return;
    }

    this.setState({ isLoading: true });
    try {
      const res = await forgotPasswordApis.forgotPassword({
        email: this.state.formError.email,
        mobile: this.state.formError.mobile,
      });
      if (res.status === 1) {
        this.setState({ snackbar: true });
        this.setState({
          email_mobile: "",
        });
      }
     
    } catch (error) {
      if (error.response) {
        this.setState({ ErrorMsg: error.response.data.message });
      } else if (error.request) {
        this.setState({ ErrorMsg: error.request });
      } else {
        this.setState({ ErrorMsg: error.message });
      }
      this.setState({ isLoading: false });
    }
  };

  handleClickOpen = () => {
    this.setState({ setOpen: true });
  };

  handleClose = (value) => {
    this.setState({ setOpen: false });
  };

  render() {
    return (
      <>
        <Grid container md={12}>
          <Box
            component={Grid}
            item
            xs={12}
            sm={6}
            md={4}
            //  lg={4}
            display={{ xs: "none", sm: "none", lg: "block", md: "none" }}
          >
            <Sidebar></Sidebar>
          </Box>
          <Box
            component={Grid}
            item
            xs={12}
            sm={6}
            md={8}
            sx={{ display: "flex", justifyContent: "center" }}
          >
            <ForgotPassword
              isLoading={this.state.isLoading}
              EmailMobileChecker={this.EmailMobileChecker}
              onSubmit={this.handleFormSubmit}
              formError={this.state.formError}
              isError={this.state.ErrorMsg}
              isOpenDialog={this.state.setOpen}
              onDialogClose={this.handleClose}
              email_mobile={this.state.email_mobile}
            ></ForgotPassword>

            <Snackbar
              open={this.state.snackbar}
              autoHideDuration={5000}
              onClose={() => this.setState({ snackbar: false })}
              anchorOrigin={{ vertical: "top", horizontal: "right" }}
            >
              <Alert severity="success">
                A Forget Password link has been send your registered
                mobile/email please check
              </Alert>
            </Snackbar>
          </Box>
        </Grid>
      </>
    );
  }
}

export default withRouter(ForgotPasswordContainer);
